import React, { useEffect, useRef, useState } from "react";

const IFRAME_SRC = "https://do7go.com/e/wf2h4pcg8zp5";

function App() {
  const [iframes, setIframes] = useState(Array(6).fill(IFRAME_SRC));
  const loaderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIframes((prev) => [...prev, ...Array(4).fill(IFRAME_SRC)]);
        }
      },
      { rootMargin: "100px" }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, []);

  return (
    <main style={{ backgroundColor: "#f3f4f6", padding: "1rem", minHeight: "100vh" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
        {iframes.map((src, idx) => (
          <iframe
            key={idx}
            src={src}
            width="100%"
            height="480"
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            style={{ borderRadius: "0.5rem", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}
          />
        ))}
      </div>
      <div ref={loaderRef} style={{ height: "80px" }}></div>
    </main>
  );
}

export default App;
